import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  $createImageNode,
  ImageNode,
  ImagePayload,
} from 'features/richText/nodes'
import {
  $getSelection,
  $isRangeSelection,
  $isRootNode,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from 'lexical'
import React, { useEffect } from 'react'

export type InsertImagePayload = Readonly<ImagePayload>

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> =
  createCommand('INSERT_IMAGE_COMMAND')

export const ImagePlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (!editor.hasNodes([ImageNode])) {
      throw new Error('ImagePlugin: ImageNode not registered on editor')
    }

    const unregister = editor.registerCommand<InsertImagePayload>(
      INSERT_IMAGE_COMMAND,
      (payload) => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
          if ($isRootNode(selection.anchor.getNode())) {
            selection.insertParagraph()
          }
          const imageNode = $createImageNode(payload)
          selection.insertNodes([imageNode])
        }
        return true
      },
      COMMAND_PRIORITY_EDITOR
    )

    return unregister
  }, [editor])

  return null
}
